module.exports = __webpack_public_path__ + "img/selected_seat.ea040479.svg";